// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-ajZd","toggle":"styles_toggle__1XBMb","preview":"styles_preview__1O8EZ"};